const services = [
  {
    icon: "ri-building-line",
    title: "Architectural Design",
    desc: "Custom building design focused on both aesthetics and functionality — from initial vision to refined, buildable plans.",
    img: "https://www.archiconservices.com/img/home-projects/anjali.jpg",
  },
  {
    icon: "ri-draft-line",
    title: "Concept Development",
    desc: "Early-stage planning, spatial layout, and creative direction that transforms ideas into structured design intent.",
    img: "https://www.archiconservices.com/img/home-projects/daria.jpg",
  },
  {
    icon: "ri-file-list-3-line",
    title: "Construction Drawings",
    desc: "Detailed, build-ready plans and documentation for accurate, efficient execution by contractors and builders.",
    img: "https://www.archiconservices.com/img/feature-pic.jpg",
  },
  {
    icon: "ri-home-gear-line",
    title: "Renovations & Additions",
    desc: "Reimagining and expanding existing structures with cohesive design that respects the original while elevating the whole.",
    img: "https://www.archiconservices.com/img/home-projects/residential.jpg",
  },
  {
    icon: "ri-layout-grid-line",
    title: "Interior Architectural Planning",
    desc: "Flow, structure, and usability of interior environments — designing spaces that feel as good as they look.",
    img: "https://www.archiconservices.com/img/home-projects/anjali-int.jpg",
  },
  {
    icon: "ri-image-line",
    title: "3D Visualization",
    desc: "Concept visualization and photorealistic rendering to communicate design intent before a single brick is laid.",
    img: "https://www.archiconservices.com/img/rendering/interior/hqdefault.jpg",
  },
];

export default function Services() {
  const handleScroll = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="services" className="py-28 px-6 bg-stone-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16 gap-6">
          <div>
            <p
              className="text-xs tracking-widest uppercase text-amber-600 mb-3"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              What We Do
            </p>
            <h2
              className="text-4xl md:text-5xl font-light text-stone-900 leading-tight"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Design Services
              <br />
              <em className="not-italic font-semibold">Built for Excellence</em>
            </h2>
          </div>
          <p
            className="text-stone-500 text-sm leading-relaxed max-w-sm"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            From concept to construction-ready documentation, every service is delivered with precision and design intent.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((svc, i) => (
            <div
              key={i}
              className="bg-white group overflow-hidden cursor-default"
            >
              {/* Image */}
              <div className="w-full h-52 overflow-hidden">
                <img
                  src={svc.img}
                  alt={svc.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              {/* Content */}
              <div className="p-7 border border-t-0 border-stone-100 group-hover:border-stone-300 transition-colors duration-300">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-7 h-7 flex items-center justify-center">
                    <i className={`${svc.icon} text-lg text-amber-600`}></i>
                  </div>
                  <h3
                    className="text-stone-900 font-medium"
                    style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.15rem" }}
                  >
                    {svc.title}
                  </h3>
                </div>
                <p
                  className="text-stone-500 text-sm leading-relaxed"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {svc.desc}
                </p>
                <div className="mt-5 w-6 h-px bg-amber-500 group-hover:w-12 transition-all duration-500"></div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-14">
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); handleScroll("#contact"); }}
            className="inline-flex items-center gap-3 border border-stone-900 text-stone-900 text-xs tracking-widest uppercase px-8 py-4 rounded-sm hover:bg-stone-900 hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Discuss Your Project
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
